import React, { Fragment } from 'react';
import { getResourceFields } from 'helpers/objectHelpers';
import FieldDisplay from 'field/display/FieldDisplay';

/**
 * Display of Object values in Edit view
 */
export default function EditResourceDisplay({value}) {
  if (!value.display) {
    if (value.uri) {
      return <p>{value.uri}</p>;
    }
    return null;
  }
  const fields = getResourceFields(value.display);
  
  if (fields) {
    return (
      <Fragment>
        {
          fields.map((field, k) => {
            if (field.label) {
              if (!field.props) field.props = {};
              field.props.noLink = true;
              return <FieldDisplay field={field} shaded={true} key={k} />;
            }
          })
        }
      </Fragment>
    );
  }
  // no fields: value.display is a Literal (String)
  else {
    return <p>{value.display}</p>;
  }
}